import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import Login from "../../pages/register/Login";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

import {
  fetchLoginRequest,
  deleteFromLoginRequest,
} from "../../redux/actions/Login";
import { clearLocalData } from "../../utils/commonFun";
import Icon from "../controls/icons/Icon";
import { GetCurrentLocation, IsMobile } from "../../utils/commonFun";

//
const LoginMenu = ({ login, fetchLogin, deleteLogin, handleOffcanvas }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  let userData = useSelector((loginData) => loginData.login.login.login);
  if (userData && typeof userData != "object") {
    userData = JSON.parse(userData);
  }

  const [loginPopup, setLoginPopup] = useState(false);
  const [userData1, setuserData] = useState(userData);

  const handleUserLoginData = (userData2) => {
    login = fetchLogin();
    //setuserData(login);
    setuserData(() => {
      return userData2.payload;
    });
  };
  /* const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  }; */

  let currentLocation = GetCurrentLocation();
  currentLocation =
    currentLocation === null || currentLocation === undefined
      ? "/"
      : currentLocation?.pathName;

  const handleLogout = async () => {
    try {
      clearLocalData();
      // navigate(currentLocation + "?successLogout");
      navigate("/");
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
    setShowMenu(() => false);
    if (handleOffcanvas) handleOffcanvas("hide");
  };

  const navigateToDashboard = () => {
    if (
      userData &&
      userData.user &&
      userData.user.role &&
      userData.user.role === process.env.REACT_APP_ROLE_PARTICIPANT
    ) {
      navigate("/create-profile");
    } else {
      navigate("/dashboard");
    }
    setShowMenu(() => false);
    if (handleOffcanvas) handleOffcanvas("hide");
  };

  const navigateToOrganizerProfile = () => {
    if (
      userData &&
      userData.user &&
      userData.user.role &&
      userData.user.role === process.env.REACT_APP_ROLE_PARTICIPANT
    ) {
      navigate("/create-profile");
    } else {
      navigate("/my-account");
    }
    setShowMenu(() => false);
    if (handleOffcanvas) handleOffcanvas("hide");
  };

  const displayMenu = () => {
    if (userData?.user) {
      setShowMenu(() => !showMenu);
    }

    if (handleOffcanvas) handleOffcanvas("hide");
  };
  useEffect(() => {
    let isMobile = IsMobile();
    if (isMobile === true) {
      if (userData && userData.user) {
        setShowMenu(() => true);
      }
    }
  });

  const onClose = () => {
    setShowMenu(() => false);
  };

  //
  return (
    <>
      {userData && userData.user ? (
        <>
          <div id="avatar" onClick={displayMenu}>
            <img src={userData?.user?.profilePicUrl} />
          </div>
          {showMenu && (
            <>
              <div
                className="custom-dropdown"
                style={{ marginTop: "2px", marginLeft: "-120px" }}
              >
                <div class="dropdown-menu dropdown-menu-right show caret">
                  <div className="sidemenuicon dropdown-item">
                    <Link onClick={handleLogout} id="btnLogout">
                      <span className="icon">
                        <Icon iconName="logout" />
                      </span>
                      Logout
                    </Link>
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="menu-heading disabled">User Account</div>

                  <div className="sidemenuicon dropdown-item">
                    <Link to="/my-info/order" onClick={() => displayMenu()}>
                      <span className="icon">
                        <Icon iconName="myorder" />
                      </span>
                      My Order
                    </Link>
                  </div>
                  <div className="sidemenuicon dropdown-item">
                    <Link to="/my-info/profile" onClick={() => displayMenu()}>
                      <span className="icon">
                        {" "}
                        <Icon iconName="profile1" />
                      </span>
                      My Profile
                    </Link>
                  </div>
                  <div className="sidemenuicon dropdown-item">
                    <Link
                      to="/my-info/notifications"
                      onClick={() => displayMenu()}
                    >
                      <span className="icon">
                        <Icon iconName="notification" />
                      </span>
                      Notification
                    </Link>
                  </div>
                  <div className="sidemenuicon dropdown-item">
                    <Link
                      to="/my-info/account-settings"
                      onClick={() => displayMenu()}
                    >
                      <span className="icon">
                        <Icon iconName="accountsetting" />                        
                      </span>
                      Account Setting
                    </Link>
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="menu-heading disabled">Organizer</div>
                  <div className="sidemenuicon dropdown-item mdnDashboard">
                    <Link to="/dashboard" onClick={navigateToDashboard}>
                      <span className="icon">
                        {/* <Icon iconName="dashboard" /> */}
                        <svg viewBox="0 0 25 25" fill="grey">
          <path
            d="M12.6908 6.44434C12.4479 6.44434 12.2149 6.54084 12.0431 6.71262C11.8714 6.88439 11.7748 7.11737 11.7748 7.36029V16.5198C11.7748 16.7628 11.8714 16.9958 12.0431 17.1675C12.2149 17.3393 12.4479 17.4358 12.6908 17.4358C12.9337 17.4358 13.1667 17.3393 13.3385 17.1675C13.5103 16.9958 13.6068 16.7628 13.6068 16.5198V7.36029C13.6068 7.11737 13.5103 6.88439 13.3385 6.71262C13.1667 6.54084 12.9337 6.44434 12.6908 6.44434ZM8.11103 11.9401C7.8681 11.9401 7.63512 12.0366 7.46335 12.2083C7.29157 12.3801 7.19507 12.6131 7.19507 12.856V16.5198C7.19507 16.7628 7.29157 16.9958 7.46335 17.1675C7.63512 17.3393 7.8681 17.4358 8.11103 17.4358C8.35395 17.4358 8.58693 17.3393 8.7587 17.1675C8.93048 16.9958 9.02698 16.7628 9.02698 16.5198V12.856C9.02698 12.6131 8.93048 12.3801 8.7587 12.2083C8.58693 12.0366 8.35395 11.9401 8.11103 11.9401ZM17.2706 10.1082C17.0277 10.1082 16.7947 10.2047 16.6229 10.3764C16.4511 10.5482 16.3546 10.7812 16.3546 11.0241V16.5198C16.3546 16.7628 16.4511 16.9958 16.6229 17.1675C16.7947 17.3393 17.0277 17.4358 17.2706 17.4358C17.5135 17.4358 17.7465 17.3393 17.9183 17.1675C18.09 16.9958 18.1865 16.7628 18.1865 16.5198V11.0241C18.1865 10.7812 18.09 10.5482 17.9183 10.3764C17.7465 10.2047 17.5135 10.1082 17.2706 10.1082ZM19.1025 2.78052H6.27912C5.55034 2.78052 4.85141 3.07002 4.33608 3.58535C3.82076 4.10067 3.53125 4.7996 3.53125 5.52838V18.3518C3.53125 19.0805 3.82076 19.7795 4.33608 20.2948C4.85141 20.8101 5.55034 21.0996 6.27912 21.0996H19.1025C19.8313 21.0996 20.5302 20.8101 21.0455 20.2948C21.5609 19.7795 21.8504 19.0805 21.8504 18.3518V5.52838C21.8504 4.7996 21.5609 4.10067 21.0455 3.58535C20.5302 3.07002 19.8313 2.78052 19.1025 2.78052ZM20.0184 18.3518C20.0184 18.5947 19.9219 18.8277 19.7502 18.9994C19.5784 19.1712 19.3454 19.2677 19.1025 19.2677H6.27912C6.03619 19.2677 5.80321 19.1712 5.63144 18.9994C5.45966 18.8277 5.36316 18.5947 5.36316 18.3518V5.52838C5.36316 5.28546 5.45966 5.05248 5.63144 4.88071C5.80321 4.70893 6.03619 4.61243 6.27912 4.61243H19.1025C19.3454 4.61243 19.5784 4.70893 19.7502 4.88071C19.9219 5.05248 20.0184 5.28546 20.0184 5.52838V18.3518Z"
            stroke-width="0"
          />
        </svg>
                      </span>
                      Dashboard
                    </Link>
                  </div>
                  <div className="sidemenuicon dropdown-item">
                    <Link to="/my-account" onClick={navigateToOrganizerProfile}>
                      <span className="icon">
                        <Icon iconName="profile1" />
                      </span>
                      Profile
                    </Link>
                  </div>
                </div>
              </div>
              <div className="custom-backdrop fade  " onClick={onClose}></div>
            </>
          )}
        </>
      ) : (
        <div className="p-2" id="btnLogin" onClick={() => setLoginPopup(true)}>
          <img src="/images/profile_circle_fill.svg" class="me-2 icon" alt="" />
        </div>
      )}

      {loginPopup &&
        createPortal(
          <Login
            onClose={() => setLoginPopup(false)}
            onUserLoginData={handleUserLoginData}
          />,
          document.body
        )}
    </>
  );
};
const mapStateToProps = (state) => ({
  login: state.login.login.login,
});
const mapDispatchToProps = (dispatch) => ({
  fetchLogin: () => dispatch(fetchLoginRequest()),
  // deleteLogin: () => dispatch(deleteFromLoginRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginMenu);
//export default DesktopMenu;
